export default __webpack_public_path__ + "static/media/poster-sdg-2.4a252544.png";